module.exports = __webpack_public_path__ + "img/bd.4de568af.svg";